export const NAVIGATION_TAB_CHANGED = 'NAVIGATION_TAB_CHANGED';
